import debugTools from "./debug";
import store from "./store";
import { URL_KEYS } from "../constants/urlKeys";

export const hasUrlKey = (key) => {
    try {
        const params = new URLSearchParams(window.location.search);

        return params.get(key) !== null;
    } catch (err) {
        return false;
    }
};

export const hasSavedAbbaPreview = async () => {
    return !!store.getPreview();
};

export const applyAbbaPreviewConfig = async (configToUse) => {
    if (hasUrlKey(URL_KEYS.ABBA_PREVIEW_KEY)) {
        // Abba Preview calls JSON.stringify and then the URL class uri-encodes the values
        // so here we need to reverse the process.
        // URLSearchParams.get will uri-decode so we don't need to manually do that
        // then will JSON.parse as the reverse of `stringify`.
        const params = new URLSearchParams(window.location.search);
        const previewConfig = JSON.parse(params.get(URL_KEYS.ABBA_PREVIEW_KEY));

        await store.setPreview(previewConfig);
        debugTools.info("Preview param detected and applying", previewConfig);

        return {
            ...configToUse,
            ...previewConfig,
        };
    } else if (hasSavedAbbaPreview()) {
        const previewConfig = await store.getPreview();

        debugTools.info("Saved preview detected and applying", previewConfig);

        return {
            ...configToUse,
            ...previewConfig,
        };
    } else {
        debugTools.debug("No preview detected.");

        return configToUse;
    }
};

export const getMockInfo = (key) => {
    if (!hasUrlKey(key)) {
        debugTools.debug(`No mock info detected for key: ${ key }`);

        return null;
    }

    const params = new URLSearchParams(window.location.search);
    const mockInfo = JSON.parse(decodeURIComponent(params.get(key)));

    debugTools.info("Found and applying mock info", mockInfo);

    return mockInfo;
};
